module.exports = __webpack_public_path__ + "static/bg-agriculture-da2c75f08ff3492c3d58f65d19d10d8b.jpg";